'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var moment = require('moment');
function _interopDefaultCompat(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    default: e
  };
}
var moment__default = /*#__PURE__*/_interopDefaultCompat(moment);
function format(input, format2) {
  return moment__default.default(input).format(format2);
}
function parse(dateString, format2) {
  const parsed = moment__default.default(dateString, format2, true);
  if (parsed.isValid()) {
    return {
      isValid: true,
      date: parsed.toDate()
    };
  }
  return {
    isValid: false,
    error: 'Invalid date. Must be on the format "'.concat(format2, '"')
  };
}
exports.format = format;
exports.parse = parse;
//# sourceMappingURL=legacyDateFormat.js.map
